<template>
  <b-modal
    visible
    :title="`Gọi chăm sóc: ${benhNhan.name} - Mã XN: ${benhNhan.testCode}`"
    ref="addBenhNhanCallModal"
    no-close-on-esc
    no-close-on-backdrop
    no-enforce-focus
    size="xxl"
    ok-title="Gửi"
    cancel-title="Hủy"
    @ok="submit"
    @hidden="hiddenHandler"
  >
    <div class="row">
      <div class="col-md">
        <h6>Thông tin bệnh nhân</h6>
        <div class="alert alert-info">
          <b>Họ và tên: </b> <span>{{ benhNhan.name ? benhNhan.name : 'Không rõ' }}</span>
          <br />
          <b>Năm sinh: </b> <span>{{ benhNhan.dob ? benhNhan.dob : 'Không rõ' }}</span>
          <br />
          <template v-if="benhNhan.age">
            <b>Tuổi: </b> <span>{{ benhNhan.age }}</span>
            <br />
          </template>
          <b>Ngày xét nghiệm: </b> <span>{{ benhNhan.testDate ? benhNhan.testDate : 'Không rõ' }}</span>
          <br />
          <template v-if="benhNhan.getOutOfHospitalDate">
            <b>Ngày ra khỏi BV/ khu cách ly: </b>
            <span>{{ benhNhan.getOutOfHospitalDate }}</span>
            <br />
          </template>
          <b>CT Value: </b> <span>{{ benhNhan.ctValue ? benhNhan.ctValue : 'Không rõ' }}</span>
          <br />
          <b>Mức CT: </b> <span>{{ benhNhan.ctLevel ? benhNhan.ctLevel : 'Không rõ' }}</span>
          <br />
          <b>Giới tính: </b>
          <span>{{ benhNhan.gender === 'unknown' ? 'Không rõ' : benhNhan.gender === 'male' ? 'Nam' : 'Nữ' }}</span>
          <br />
          <b>Lý do xét nghiệm: </b> <span>{{ benhNhan.testReason ? benhNhan.testReason : 'Không rõ' }}</span>
          <br />
          <b v-if="benhNhan.note">Ghi chú: </b> <span>{{ benhNhan.note }}</span>
        </div>
        <b-row>
          <div class="mt-2">
            <button
              class="btn btn-success btn-xl"
              variant="success"
              @click="startCall()"
              v-if="!callStatus || (callStatus && callStatus === 'ended')"
            >
              <i class="fa fa-phone"></i> Gọi điện
            </button>
            <button class="btn btn-danger btn-xl" @click="endCall()" v-if="callStatus && callStatus !== 'ended'">
              <i class="icon16-call-end-white"></i> Kết thúc
            </button>
          </div>
          <div class="mt-2">
            <button class="btn btn-warning btn-xl" @click="openReportModal()">
              <i class="fa fa-info"></i> Phản ánh
            </button>
          </div>
        </b-row>
        <hr />
        <h5>Câu hỏi sàng lọc, tư vấn</h5>
        <div class="alert alert-success" v-if="$store.state.user.client._id === '6113dd134c2a3f5bef767944' || $store.state.user.client._id === '5e587b29356b577b2d0a279d'">
          Đánh giá kiến thức, hiểu biết, thắc mắc của người bệnh về CoViD-91 => tư vấn sức khỏe về CoViD-19 (trừ trường hợp người bệnh tỏ ra lo lắng cần hỗ trợ y tế ngay).
        </div>
        <b-form-group
          v-for="(section, index) in questionList"
          :key="section.section_id"
          :label="`${index + 1}. ${section.text}`"
        >
          <b-form-checkbox-group
            stacked
            :id="section.section_id"
            v-model="formData.checkboxes"
            :options="section.question_list"
            :name="section.section_id"
            @change="onChangeQuestionCheckbox"
          >
          </b-form-checkbox-group>
        </b-form-group>
        <template v-if="formData.score <=0">
          <hr />
          <form-checkbox
              :model="formData"
              attribute="khongTrieuChung"
              :errors="formErrors"
              chk-label="Xác nhận không có triệu chứng gì trong các triệu chứng kể trên."
          >
          </form-checkbox>
        </template>
      </div>
      <div class="col-md">
        <b-form-group label="Điểm (0-100)">
          <b-form-input v-model="formData.score" type="number" :readonly="true" />
        </b-form-group>
        <form-select :model="formData" attribute="tier" label="Nhóm NC" :options="tierOptions" disabled></form-select>
        <div v-html="formData.suggestion" class="alert alert-warning" v-if="formData.suggestion"></div>
        <hr />
        <b-form-group label="Ghi chú">
          <b-form-textarea v-model="formData.note" rows="5" placeholder="Nhập chi tiết tình trạng của bệnh nhân"/>
        </b-form-group>
        <hr />
        <form-radio-group
          :stacked="true"
          :model="formData"
          attribute="nextStep"
          :errors="formErrors"
          label="Bước tiếp theo"
          :options="nextStepOptions"
        ></form-radio-group>
        <div v-if="formData.nextStep === 'continue'">
          <div>
            <label>Lịch gọi lần tiếp theo: </label>
            <b-button
                v-for="(option, index) in nextCallOptions"
                variant="link"
                size="sm"
                :key="index"
                @click="formData.nextCallTime = option.value"
            >{{ option.text }}</b-button
            >
          </div>
          <form-date-time
            :model="formData"
            attribute="nextCallTime"
            format="HH:mm DD/MM/YYYY"
            :errors="formErrors"
            placeholder="Chọn thời gian gọi lần tiếp theo"
          >
          </form-date-time>
        </div>
        <div v-if="formData.nextStep === 'request-unfollow'">
          <form-select
            label="Lý do ngừng theo dõi"
            :model="formData"
            attribute="stopFollowReason"
            :errors="formErrors"
            :options="OPTIONS_STOP_FOLLOW_REASON"
          ></form-select>
          <form-input
            label="Mô tả"
            :model="formData"
            attribute="stopFollowReasonDetail"
            :errors="formErrors"
          ></form-input>
          <b-alert show variant="warning">
            Khi xác nhận Đề xuất ngừng theo dõi, bạn đồng ý chịu trách nhiệm về việc xác thực thông tin này. Sau khi xác
            nhận, yêu cầu ngừng theo dõi bệnh nhân này sẽ được gửi cho Bác sĩ của bạn. Hãy liên hệ với Bác sĩ để được
            phê duyệt yêu cầu.
          </b-alert>
        </div>
        <div v-if="formData.nextStep === 'unfollow'">
          <form-select
            label="Lý do ngừng theo dõi"
            :model="formData"
            attribute="stopFollowReason"
            :errors="formErrors"
            :options="OPTIONS_STOP_FOLLOW_REASON"
          ></form-select>
          <form-input
            label="Mô tả"
            :model="formData"
            attribute="stopFollowReasonDetail"
            :errors="formErrors"
          ></form-input>
          <b-alert show variant="warning">
            Khi xác nhận Ngừng theo dõi, bạn đồng ý chịu trách nhiệm về việc xác thực thông tin này.
          </b-alert>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md">
        <b class="text-danger">
          Chú ý: Hỏi bệnh nhân xem còn triệu chứng nào khác không, nếu có xin nhập thông tin vào phần Ghi chú.
        </b>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" class="float-right" @click="hiddenHandler">{{ $t('cancel') }}</b-button>
      <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="submit">
        <b-spinner v-if="saveLoading" small></b-spinner>
        {{ $t('save') }}
      </b-button>
    </template>

    <b-modal
      size="xm"
      v-model="reportModal"
      title="Phản ánh cuộc gọi"
      @ok="createReport"
      no-close-on-backdrop
      no-enforce-focus
    >
      <b-form-row>
        <b-col cols="12">
          <form-select
            :model="formReport"
            :errors="formErrors"
            attribute="fault"
            label="Lý do phản ánh"
            :options="reportFaultOptions"
          >
          </form-select>
          <form-textarea
            :model="formReport"
            :errors="formErrors"
            attribute="faultDetail"
            label="Nội dung chi tiết"
            rows="5"
            placeholder="Thông tin chi tiết nếu có"
          />
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="reportModal = false">Hủy</b-button>
        <b-button variant="primary" class="float-right" @click="createReport" :disabled="reportLoading">
          <b-spinner small v-if="reportLoading"></b-spinner>
          Gửi
        </b-button>
      </template>
    </b-modal>
  </b-modal>
</template>

<script>
import OPTIONS_STOP_FOLLOW_REASON from './constants/options-stop-follow-reason.json';
import QUESTION_LIST from './constants/benh-nhan-call-question-list.json';
import TIER_INFO from './constants/tier-info.json';
import console from 'console';
import moment from 'moment';
import FormCheckbox from '../../components/form/FormCheckbox.vue';
import store from '@/store';

export default {
  components: {FormCheckbox},
  inheritAttrs: false,
  props: {
    benhNhan: Object,
  },
  created() {
    this.loadLastestBenhNhanCall();
    this.OPTIONS_STOP_FOLLOW_REASON = OPTIONS_STOP_FOLLOW_REASON;
    this.QUESTION_LIST = QUESTION_LIST;
    this.TIER_INFO = TIER_INFO;
  },
  data() {
    return {
      nextCallOptions: [
        {
          value: moment()
            .startOf('day')
            .add(21, 'hours'),
          text: 'Tối nay',
        },
        {
          value: moment()
            .startOf('day')
            .add(1, 'days')
            .add(9, 'hours'),
          text: 'Sáng mai',
        },
        {
          value: moment()
            .startOf('day')
            .add(1, 'days')
            .add(21, 'hours'),
          text: 'Tối mai',
        },
      ].filter(option => option.value.valueOf() > moment().valueOf()),
      formData: {
        score: 0,
        checkboxes: [],
        tier: null,
        suggestion: '',
        nextStep: !this.benhNhan.stopFollowTime && !this.benhNhan.stopFollowRequestTime ? 'continue' : 'none',
        nextCallTime: null,
        stopFollowReason: null,
        stopFollowReasonDetail: '',
        note: '',
        callId: null,
        khongTrieuChung: false,
      },
      saveLoading: false,
      formErrors: [],
      callStatus: null,
      // Report call modal
      reportModal: false,
      formReport: {
        fault: null,
        faultDetail: null,
      },
      reportFaultOptions: [
        {value: null, text: 'Chọn lý do phản ánh'},
        {value: 'khongnghemay', text: 'Bệnh nhân không nghe máy'},
        {value: 'saiso', text: 'Số điện thoại không đúng'},
        {value: 'saithongtin', text: 'Sai thông tin bệnh nhân'},
      ],
      reportLoading: false,
    };
  },
  computed: {
    hasFullAccessPermission() {
      if (this.benhNhan == null) return false;
      return (
        ['owner', 'bac-sy-truong-nhom'].includes(this.$store.state.user.role) ||
        (this.$store.state.user.role === 'bac-sy' && ['nc0', 'nc1', 'nc2'].includes(this.benhNhan.tier))
      );
    },
    tierOptions() {
      return [
        {value: null, text: 'Phân loại'},
        {value: 'nc0', text: 'NC0'},
        {value: 'nc1', text: 'NC1'},
        {value: 'nc2', text: 'NC2'},
        {value: 'nc3', text: 'NC3'},
        {value: 'nc4', text: 'NC4'},
      ];
    },
    nextStepOptions() {
      const {stopFollowTime, stopFollowRequestTime} = this.benhNhan || {};
      return [
        stopFollowTime || stopFollowRequestTime ? {value: 'none', text: 'Không'} : null,
        !stopFollowTime ? {value: 'continue', text: 'Tiếp tục theo dõi bệnh nhân'} : null,
        !this.hasFullAccessPermission && !stopFollowTime && !stopFollowRequestTime
          ? {value: 'request-unfollow', text: 'Đề xuất ngừng theo dõi'}
          : null,
        this.hasFullAccessPermission && !stopFollowTime ? {value: 'unfollow', text: 'Ngừng theo dõi'} : null,
      ].filter(element => element != null);
    },
    questionList() {
      // '5e587b29356b577b2d0a279d', //dev
      // '60feaebf8d296e0cb897910f', //hcm
      // '6111dd414fa8513685dc77ea', //bd
      // '6113dd134c2a3f5bef767944', //hn
      if ([
        '5e587b29356b577b2d0a279d', //dev
        '6113dd134c2a3f5bef767944', //hn
      ].includes(this.$store.state.user.client._id)) {
        let result = [];
        result.push(this.QUESTION_LIST[2]); // Triệu chứng ít gặp
        result.push(this.QUESTION_LIST[3]); // Triệu chứng thường gặp
        result.push(this.QUESTION_LIST[4]); // Yếu tố tăng nặng
        result.push(this.QUESTION_LIST[0]); // Triệu chứng nặng
        result.push(this.QUESTION_LIST[1]); // Biến chứng toàn phát
        return result;
      }
      return this.QUESTION_LIST
    }
  },
  watch: {
    'formData.checkboxes'(value) {
      this.onChangeQuestionCheckbox(value);

      if (value && value.length > 0) this.formData.khongTrieuChung = false;
    },
    'formData.tier'(value) {
      this.onChangeTierOption(value);
    },
    'formData.khongTrieuChung'(value) {
      if (value) {
        this.formData.tier = 'nc0';
        this.formData.checkboxes = [];
      }
    },
  },
  mounted() {
    this.$bus.$on('callStatusUpdated', this.callStatusUpdated);
  },
  methods: {
    submit() {
      this.validate();
      if (this.formErrors.length == 0) {
        this.saveLoading = true;
        this.$service
          .post('/benh-nhan-call', {
            benhNhan: this.benhNhan._id,
            formDetails: JSON.stringify(this.formData.checkboxes),
            tier: this.formData.tier,
            score: this.formData.score,
            note: this.formData.note,
            nextStep: this.formData.nextStep,
            nextCallTime: this.formData.nextStep === 'continue' ? this.formData.nextCallTime : undefined,
            stopFollowReason:
              this.formData.nextStep === 'request-unfollow' || this.formData.nextStep === 'unfollow'
                ? this.formData.stopFollowReason
                : undefined,
            stopFollowReasonDetail:
              this.formData.nextStep === 'request-unfollow' || this.formData.nextStep === 'unfollow'
                ? this.formData.stopFollowReasonDetail
                : undefined,
            callId: this.formData.callId,
            requester: {name: store.state.user.name, id: store.state.user._id},
          })
          .then(response => {
            if (response && response.data) {
              this.$swal({
                icon: 'success',
                text: 'Ghi nhận thông tin thành công',
                toast: true,
                timer: 5000,
                position: 'top-end',
              });
              this.$bus.$emit('reloadBenhNhanList');
            }
            this.hiddenHandler();
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
              this.$swal({
                icon: 'error',
                text: error.response.data.message,
              });
            } else {
              this.formErrors = error.response.data;
            }
            console.log(error);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },
    validate() {
      this.formErrors = [];
      if (!this.formData.nextStep) {
        this.formErrors.push({
          param: 'nextStep',
          msg: 'Vui lòng chọn bước tiếp theo',
          location: 'body',
        });
      }
      switch (this.formData.nextStep) {
        case 'continue': {
          if (this.formData.nextCallTime < moment()) {
            this.formErrors.push({
              param: 'nextCallTime',
              msg: 'Vui lòng nhập thời gian gọi trong tương lai.',
              location: 'body',
            });
          }
          break;
        }
        case 'request-unfollow':
        case 'unfollow': {
          if (this.formData.stopFollowReason === null) {
            this.formErrors.push({
              msg: 'Vui lòng chọn lý do ngừng theo dõi',
              param: 'stopFollowReason',
            });
          }
          if (this.formData.stopFollowReason === 'khac' && this.formData.stopFollowReasonDetail === '') {
            this.formErrors.push({
              msg: 'Vui lòng điền thông tin chi tiết về lí do ngừng theo dõi',
              param: 'stopFollowReasonDetail',
            });
          }
          break;
        }
      }
      if (this.formData.nextStep === 'continue') {
        // only validate nextCallTime if nextStep is 'continue'
        if (this.formData.nextCallTime < moment()) {
          this.formErrors.push({
            param: 'nextCallTime',
            msg: 'Vui lòng nhập thời gian gọi trong tương lai.',
            location: 'body',
          });
        }
      }
      if (this.formData.checkboxes.length === 0 && !this.formData.khongTrieuChung) {
        this.formErrors.push({
          param: 'khongTrieuChung',
          msg: 'Trường hợp không có triệu chứng vui lòng chọn vào đây.',
          location: 'body',
        });
      }
    },
    loadLastestBenhNhanCall() {
      this.$service
        .get('/benh-nhan-call', {
          params: {
            benhNhan: this.benhNhan._id,
            page: 1,
            pageSize: 1,
            type: 'care',
          },
        })
        .then(response => {
          const docs = response.data.docs || [];
          if (docs.length > 0) {
            this.formData.note = docs[0].note;
            this.formData.checkboxes = JSON.parse(docs[0].formDetails[0]);
            this.formData.nextCallTime = moment().add(1, 'day');
          }
        })
        .catch(error => {
          if (error.response.data.message) {
            this.$swal({
              text: error.response.data.message,
              icon: 'error',
            });
          }
        })
        .finally(() => {});
    },
    onChangeQuestionCheckbox(questionValues) {
      let totalScore = 0;
      let scoreBySection = Object.fromEntries(QUESTION_LIST.map(section => [section.section_id, 0.0]));
      questionValues.forEach(element => {
        for (const section of QUESTION_LIST) {
          for (const question of section.question_list) {
            if (question.value == element) {
              scoreBySection[section.section_id] = (scoreBySection[section.section_id] || 0) + question.weight;
              totalScore += question.weight;
            }
          }
        }
      });
      this.formData.score = totalScore;
      this.formData.tier = this.suggestTier(totalScore, scoreBySection);
    },
    onChangeTierOption(value) {
      let tierMsg = '';
      if (value) {
        const advices = TIER_INFO[value].advices.join('<br>');
        const notes = TIER_INFO[value].notes.join('<br>');
        tierMsg = `TƯ VẤN:<br>${advices}<br><br>LƯU Ý:<br>${notes}<br>`;
      }
      this.formData.suggestion = tierMsg;
    },
    suggestTier(totalScore, scoreBySection) {
      switch (true) {
        case totalScore > 30 || scoreBySection['S2000'] >= 6:
          return 'nc4';
        case totalScore >= 22 || scoreBySection['S1000'] >= 8:
          return 'nc3';
        case totalScore >= 14 || scoreBySection['S1000'] >= 4:
          return 'nc2';
        case totalScore >= 6:
          return 'nc1';
        default:
          return 'nc0';
      }
    },
    callStatusUpdated(_number, callId, callStatus) {
      this.formData.callId = callId;
      this.callStatus = callStatus;
    },
    startCall() {
      if (this.benhNhan.phone) {
        this.$bus.$emit('makeCall', this.benhNhan.phone);
      }
    },
    endCall() {
      this.$bus.$emit('endCall');
    },
    hiddenHandler() {
      this.$emit('hidden');
      this.$bus.$off('callStatusUpdated');
      this.endCall();
    },
    openReportModal() {
      this.reportModal = true;
    },
    createReport() {
      this.reportLoading = true;
      this.$bgService
        .post('/benh-nhan/report/' + this.benhNhan._id, {
          fault: this.formReport.fault,
          faultDetail: this.formReport.faultDetail,
        })
        .then(response => {
          if (response.data) {
            this.$swal({
              title: this.$t('success'),
              text: 'Phản ánh tình trạng bệnh nhân thành công',
              icon: 'success',
              toast: true,
              position: 'top-end',
              timer: 5000,
            });
            this.hiddenHandler();
            this.$bus.$emit('reloadBenhNhanList');
          } else {
            this.$swal({
              title: this.$t('error'),
              text: 'Phản ánh tình trạng bệnh nhân thất bại',
              icon: 'error',
            });
          }
          this.reportModal = false;
        })
        .catch(error => {
          if (error.response.data.message) {
            this.$swal({
              text: error.response.data.message,
              icon: 'error',
            });
            this.reportModal = false;
          } else {
            this.formErrors = error.response.data;
          }
        })
        .finally(() => {
          this.formReport = {};
          this.reportLoading = false;
        });
    },
  },
};
</script>
